module.exports = __webpack_public_path__ + "img/mentalIco.7f061803.svg";